import React from 'react';
import { RouteTitle } from '../routes/models';
import getPartnerAsset, { DynamicAssetsKeys } from '../assets';
import { useTitle } from '../hooks';

const PageTitle: React.FunctionComponent<{
  title: RouteTitle | string | undefined;
}> = (props) => {
  const skipTitle = ((props.title as RouteTitle) && (props.title as RouteTitle).isOverridden) || false;
  if (skipTitle !== true) {
    const title =
      typeof props.title === 'string' ? props.title : (props.title as RouteTitle) && (props.title as RouteTitle).value;
    useTitle(title);
  }
  return <></>;
};

export default PageTitle;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/PageTitle.tsx